import { createApi } from '@reduxjs/toolkit/query/react';
import config from 'config/index';
import axiosBaseQuery from 'rtk/query/axiosBaseQuery';
import { EUserType } from 'types/accessControll.types';
import type { Notification } from 'types/notification.types';

const reducerPath = 'notifications' as const;
const path = 'v1/notifications' as const;

export const notificationsApi = createApi({
  reducerPath: reducerPath,
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.VITE_BACKEND_URL}/${path}`,
  }),
  endpoints: (builder) => ({
    getNotifications: builder.query<{ notifications: Notification[] }, void>({
      query: () => ({
        url: ``,
        method: 'GET',
        headers: {
          'X-Access-Control': EUserType.ANY,
        },
      }),
    }),

    getUnreadNotifications: builder.query<{ notifications: any[] }, void>({
      query: () => ({
        url: `/unread`,
        method: 'GET',
        headers: {
          'X-Access-Control': EUserType.ANY,
        },
      }),
    }),

    markNotificationAsRead: builder.mutation<any, { notification: Notification }>({
      query: (x) => ({
        url: `/mark-as-read`,
        method: 'POST',
        data: x,
        headers: { 'X-Access-Control': EUserType.ANY },
      }),
    }),
  }),
});

export const {
  // Queries
  useGetNotificationsQuery,
  useGetUnreadNotificationsQuery,
  // Mutations
  useMarkNotificationAsReadMutation,
} = notificationsApi;
